module.exports = __webpack_public_path__ + "assets/images/897a6c759d49cd7fefa2c707eec6167a.png";